import type { PageNavigation } from 'navigation/types';

import * as urls from '../urls';

export const SUSTAINABILITY_NAVIGATION: PageNavigation = {
  pageUrl: urls.getSustainabilityUrl(),
  currentLink: { text: 'Sustainability', href: urls.getSustainabilityUrl() },
  links: [
    {
      text: 'Environment',
      href: urls.getSustainabilityEnvironmentUrl(),
    },
    {
      text: 'Social',
      href: urls.getSustainabilitySocialUrl(),
    },
    {
      text: 'Governance',
      href: urls.getSustainabilityGovernanceUrl(),
    },
    {
      text: 'Reports and Policies',
      href: urls.getSustainabilityReportListUrl('esg'),
      matchHref: urls.getSustainabilityReportsUrl(),
    },
  ],
};
